var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhiteFolderIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36.9083,
    height: 36.9083,
    rx: 4,
    fill: "#F5F6FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7285 23.4736C25.7285 23.8715 25.5705 24.253 25.2892 24.5343C25.0079 24.8156 24.6263 24.9736 24.2285 24.9736H12.2285C11.8307 24.9736 11.4492 24.8156 11.1679 24.5343C10.8866 24.253 10.7285 23.8715 10.7285 23.4736V12.9736C10.7285 12.5758 10.8866 12.1943 11.1679 11.913C11.4492 11.6317 11.8307 11.4736 12.2285 11.4736H15.9785L17.4785 13.7236H24.2285C24.6263 13.7236 25.0079 13.8817 25.2892 14.163C25.5705 14.4443 25.7285 14.8258 25.7285 15.2236V23.4736Z",
    stroke: "#1F1F1F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteFolderIcon);
export default __webpack_public_path__ + "static/media/white-folder-icon.d507725ae9dbdc2a2d139492861453da.svg";
export { ForwardRef as ReactComponent };